// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"a685cf3e7a4eaa9de574","691":"ea00d4f7895d5ebd1b27","826":"c5b4a46b83fd788c7fc0","843":"9e6b01c437ea801c1b7e"}[chunkId] + ".js";
};